import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import Cookies from 'universal-cookie'
import { toast } from 'react-toastify'

import MsgBox from '../components/Layout/MsgBox'

import {
    changeInputs,
    signIn
} from '../actions/auth'

import { clearMessage } from '../actions/common'

import '../css/signin.css'
import 'css-tooltip/dist/css-tooltip.css'


import bg from '../img/bg-1.jpg'
import logo from '../img/logo.png'

const cookies = new Cookies()

const inputSm = {
	height: '30px',
    padding: '5px 10px',
    fontSize: '12px',
    lineHeight: '1.5'
}

class SignIn extends Component {
    componentWillMount() {
        this.props.clearMessage()
        const token = cookies.get('token')
        if (token) {
            this.props.history.push(window.FOLDER + '/')
        }
    }

    componentDidUpdate() {
        this.props.clearMessage()
    }

	render() {
        const { username, password, processing } = this.props
        if (this.props.message) {
            const { message } = this.props
            switch (message.get('type')) {
                case 'danger':
                    toast.error(message.get('message'))
                    break
                case 'warning':
                    toast.warn(message.get('message'))
                    break
                case 'success':
                    toast.success(message.get('message'))
                    break
                default:
                    toast.info(message.get('message'))
            }
        }

		return (
            <div className="signin-container" style={{ backgroundImage: `url(${bg})` }}>
                <div className="login-box animated fadeIn">
                    <div className="col col-md-6 text-center" style={{ paddingTop: '45px' }}>
                        <div className="col col-md-12 icesi" style={{ borderRight: '1px solid #fff', alignSelf: 'center' }}>
                            <img src={ logo } style={{ verticalAlign: 'middle' }} alt="logo" />
                        </div>
                    </div>
                    <div className="col col-md-6">
                        <p className="text-center" style={{ fontSize: '24px', fontWeight: 300, margin: '30px 0' }}>
                            Inicio de sesión
                        </p>
                        <form onSubmit={ e => { e.preventDefault(); this.props.signIn({ username: this.props.username, password: this.props.password }) }}>
                            <div className="col col-md-10 col-md-offset-1">
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-addon">
                                            <i className="fa fa-user"></i>
                                        </div>
                                        <input type="text" className="form-control input-sm" value={ username } onChange={ e => this.props.changeInputs('username', e.target.value) } placeholder="Nombre de usuario" style={ inputSm }/>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-md-10 col-md-offset-1">
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-addon">
                                            <i className="fa fa-lock"></i>
                                        </div>
                                        <input type="password" className="form-control input-sm" value={ password } onChange={ e => this.props.changeInputs('password', e.target.value) } placeholder="Contraseña" style={ inputSm }/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-10 col-md-offset-1 text-center">
                                <div className="checkbox">
                                    <label>
                                        <input type="checkbox" name="rememberme" value="1" style={{ color: '#fff' }} />
                                        Recordarme
                                    </label>
                                    <br />
                                    <small>
                                        <strong style={{cursor: 'pointer'}} className='pulse tooltip-multiline tooltip-bottom' data-tooltip='Para recuperar contraseñas: usuarios de la universidad, contáctese con el departamento de SYRI; usuarios externos, comuníquese con el departamento de compras.'>¿Olvidó su contraseña?</strong>
                                    </small>
                                </div>
                            </div>
                            <br />
                            <div className="col col-md-10 col-md-offset-1 text-center">
                                <button className="btn btn-default btn-sm" style={{ padding: '5px 30px' }} disabled={ processing }>{ processing ? <span><FontAwesome name="circle-o-notch" spin/> Iniciando sesión ...</span> : <span>Inciar sesión</span> }</button>
                            </div>
                        </form>
                    </div>
                </div>
                <MsgBox />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        username: state.auth.get('username'),
        password: state.auth.get('password'),
        processing: state.auth.get('processing'),
        message: state.common.get('message')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        changeInputs: (attr, value) => dispatch(changeInputs(attr, value)),
        signIn: (credentials) => dispatch(signIn(credentials)),
        clearMessage: () => dispatch(clearMessage())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)



// WEBPACK FOOTER //
// ./src/containers/SignIn.jsx